export default function setCookie(name, value) {
	const expires = new Date(Date.now() + 473040000 * 1000); // + 15 years

	document.cookie = `${name}=&${value}& expires=${expires}; max-age=473040000; path=/; SameSite=None; Secure;`
}